const titleHubFilters = {
  All: 'all',
  ShipToAcv: 'shipToAcv',
  Shipped: 'shipped',
  Received: 'received',
};

export const titleHubFilterLabels = {
  [titleHubFilters.All]: 'All',
  [titleHubFilters.ShipToAcv]: 'Ship Title To ACV',
  [titleHubFilters.Shipped]: 'Shipped',
  [titleHubFilters.Received]: 'Received',
};

export default titleHubFilters;
